import React from "react";
import { useInView } from "react-intersection-observer";

// css
import * as styles from "./HealthRecovery.module.css";

const HealthRecoveryComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.healthRecoveryWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>Health Recovery Stages</h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className={styles.stagesGrid}>
              {/* Stage 1: 1-3 Months */}
              <div className={styles.stageCard}>
                <div className={styles.stageHeader}>
                  <h3 className={styles.stageTime}>1-3</h3>
                  <p className={styles.stageLabel}>Months</p>
                </div>
                <div className={styles.stageContent}>
                  <h4 className={styles.stageTitle}>Normalise Metabolism</h4>
                  <p className={styles.stageDescription}>
                    Reduce body's internal stress and harmful sugar and fat
                    build-up
                  </p>
                </div>
              </div>

              {/* Stage 2: 3-6 Months */}
              <div className={styles.stageCard}>
                <div className={styles.stageHeader}>
                  <h3 className={styles.stageTime}>3-6</h3>
                  <p className={styles.stageLabel}>Months</p>
                </div>
                <div className={styles.stageContent}>
                  <h4 className={styles.stageTitle}>Healing Metabolism</h4>
                  <p className={styles.stageDescription}>
                    Optimize chronic conditions
                  </p>
                </div>
              </div>

              {/* Stage 3: 6-9 Months */}
              <div className={styles.stageCard}>
                <div className={styles.stageHeader}>
                  <h3 className={styles.stageTime}>6-9</h3>
                  <p className={styles.stageLabel}>Months</p>
                </div>
                <div className={styles.stageContent}>
                  <h4 className={styles.stageTitle}>Improved Organ Health</h4>
                  <p className={styles.stageDescription}>
                    Support cellular regeneration
                  </p>
                </div>
              </div>

              {/* Stage 4: 9-12 Months */}
              <div className={styles.stageCard}>
                <div className={styles.stageHeader}>
                  <h3 className={styles.stageTime}>9-12</h3>
                  <p className={styles.stageLabel}>Months</p>
                </div>
                <div className={styles.stageContent}>
                  <h4 className={styles.stageTitle}>Achieve Remission</h4>
                  <p className={styles.stageDescription}>
                    Beta Cell Regeneration Optimal Insulin Resistance
                  </p>
                </div>
              </div>

              {/* Stage 5: 12+ Months */}
              <div className={styles.stageCard}>
                <div className={styles.stageHeader}>
                  <h3 className={styles.stageTime}>12+</h3>
                  <p className={styles.stageLabel}>Months</p>
                </div>
                <div className={styles.stageContent}>
                  <h4 className={styles.stageTitle}>Sustain</h4>
                  <p className={styles.stageDescription}>
                    Optimal Metabolic Memory
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthRecoveryComponent;
